import styled from "styled-components";

export const HeroActions = styled.div.attrs({
  className: "space-y-s"
})``;
